import { FEATURES, SEARCH_GROUPS } from '@constants/Text'
import { lazyLoadView } from '@utils/LazyLoad'

export default [
  {
    path: '/comercial',
    name: 'commercial',
    redirect: '/comercial/sdr',
    meta: {
      can_show: FEATURES.IA_SDR,
      search: {
        title: 'Comercial',
        description: 'IA SDR: prospecção e mesa digital comercial',
        keywords: [
          'comercial',
          'sdr',
          'ia',
          'prospecção',
          'vendas',
          'mesa digital',
        ],
        icon: 'chats',
        group: SEARCH_GROUPS.FERRAMENTAS,
      },
    },
    component: () =>
      lazyLoadView(
        import('@/src/modules/commercial/views/nav-bar/commercial-nav-bar.vue')
      ),
    children: [
      {
        path: 'sdr',
        name: 'commercial.sdr',
        meta: {
          can_show: FEATURES.IA_SDR,
        },
        component: () =>
          lazyLoadView(
            import('@/src/modules/commercial/views/sdr/view-sdr.vue')
          ),
      },
      {
        path: 'configuracoes',
        name: 'commercial.settings',
        meta: {
          can_show: FEATURES.IA_SDR,
          search: {
            title: 'Configurações do Comercial',
            description: 'Configurar IA SDR e regras comerciais',
            keywords: ['configurações', 'comercial', 'sdr', 'regras'],
            group: SEARCH_GROUPS.FERRAMENTAS,
          },
        },
        component: () =>
          lazyLoadView(
            import('@/src/modules/commercial/views/settings/view-settings.vue')
          ),
      },
      {
        path: 'mesa-digital',
        name: 'commercial.mesa',
        meta: {
          can_show: FEATURES.IA_SDR_SIMULATION,
          search: {
            title: 'Mesa Digital',
            description: 'Simulação e atendimento da mesa digital',
            keywords: ['mesa digital', 'simulação', 'comercial', 'atendimento'],
            group: SEARCH_GROUPS.FERRAMENTAS,
          },
        },
        component: () =>
          lazyLoadView(
            import(
              '@/src/modules/commercial/views/mesa-digital/view-mesa-digital.vue'
            )
          ),
      },
    ],
  },
]
